import Vue from 'vue';
import App from './App.vue';
import router from '../../router/main';

import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/ru-RU';

import Inputmask from 'inputmask';

import '../../assets/scss/style.scss';

Vue.config.productionTip = false;

Vue.use(ElementUI, { locale });

Vue.directive('mask', {
    bind: function (el, binding) {
        Inputmask(binding.value).mask(el.getElementsByTagName('INPUT')[0])
    }
})

new Vue({
    router,
    render: (h) => h(App),
}).$mount('#app');
